export default __webpack_public_path__ + "static/media/Ballroll_00206.59d05556.png";